// extracted by mini-css-extract-plugin
export var blockContent = "CitySection-module--blockContent--LaDB6";
export var citySection = "CitySection-module--citySection--kqfDR";
export var container = "CitySection-module--container--+fsnL";
export var headline = "CitySection-module--headline--5Uo+k";
export var twoCols = "CitySection-module--twoCols--aF1rm";